export default __webpack_public_path__ + "static/media/016-p.f4a539af.svg";